
import { useState } from 'react';
import { useToast } from './use-toast';
import { supabase } from '@/integrations/supabase/client';

export const useKnowledgeEmbeddings = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const { toast } = useToast();

  const generateEmbeddings = async (articleId: string, companyId: string) => {
    try {
      setIsGenerating(true);
      
      // Get the session for authentication
      const { data: { session } } = await supabase.auth.getSession();
      
      if (!session) {
        throw new Error('Authentication required');
      }
      
      const { data, error } = await supabase.functions.invoke('generate-embeddings', {
        body: { articleId, companyId },
        headers: {
          Authorization: `Bearer ${session.access_token}`
        }
      });
      
      if (error) {
        throw error;
      }
      
      toast({
        title: 'Embeddings generated',
        description: data.message || 'Article content has been processed for AI support',
      });
      
      return data;
    } catch (error) {
      console.error('Error generating embeddings:', error);
      toast({
        title: 'Error',
        description: error.message || 'Failed to generate embeddings',
        variant: 'destructive',
      });
      return null;
    } finally {
      setIsGenerating(false);
    }
  };

  return {
    generateEmbeddings,
    isGenerating
  };
};
